import { FormattedMessage } from 'react-intl'
import { useMutation, useApolloClient, gql } from '@apollo/client'

import styled from 'styled-components'

import { getUnprocessableErrors } from 'utils/error'
import { Button } from 'components/v2/Button'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { resolvers as cartsResolvers } from 'resolvers/carts'

const ModalContainer = styled(Modal.Container)`
  max-width: 600px;
`

const RETURN_CART = gql`
  mutation ReturnCart($cartId: ID!) {
    returnCart(input: { id: $cartId })
  }
`

const RETURN_LOCAL_CART = gql`
  mutation ReturnLocalCart($cartId: ID!) {
    returnCart(cartId: $cartId) @client
  }
`

export const ReturnCartModal = ({ cart, closeModal }: TSFixMe): TSFixMe => {
  const client = useApolloClient()
  client.addResolvers(cartsResolvers)

  const [returnLocalCart] = useMutation(RETURN_LOCAL_CART)
  const [returnCart, { loading, error }] = useMutation(RETURN_CART, {
    onCompleted() {
      returnLocalCart({
        variables: {
          cartId: cart.id
        }
      })
      closeModal()
    }
  })

  const handleReturnCart = (): TSFixMe => {
    returnCart({
      variables: {
        cartId: cart.id
      }
    })
  }

  return (
    <ModalContainer large>
      <Modal.Header>
        <Heading.H5>
          <FormattedMessage
            id="spanish.carts.return.title"
            defaultMessage="Liberar carrito {cartName}"
            values={{
              cartName: cart.name
            }}
          />
        </Heading.H5>
      </Modal.Header>

      <Modal.Content>
        <div>
          <FormattedMessage
            id="spanish.carts.return.description"
            defaultMessage="Deseas liberar el carrito <strong>{cartName}</strong>"
            values={{
              cartName: cart.name,
              strong: (msg): TSFixMe => <strong>{msg}</strong>
            }}
          />
        </div>
      </Modal.Content>

      <Modal.Footer>
        {error && (
          <Modal.ErrorMessage>
            <ErrorMessage errors={getUnprocessableErrors(error)}>
              <FormattedMessage id="spanish.carts.return.error" defaultMessage="Hubo un error." />
            </ErrorMessage>
          </Modal.ErrorMessage>
        )}
        <Modal.Actions>
          <Button kind="cancel" onClick={(): TSFixMe => closeModal()}>
            <FormattedMessage id="spanish.dictionary.close" defaultMessage="Cerrar" />
          </Button>
          <Button kind="primary" loading={loading} onClick={handleReturnCart}>
            <FormattedMessage id="spanish.carts.return.action" defaultMessage="Liberar carrito" />
          </Button>
        </Modal.Actions>
      </Modal.Footer>
    </ModalContainer>
  )
}
